var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-flex justify-content-center align-content-center"},[_c('img',{staticClass:"align-self-center",staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"src":_vm.previewImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }